import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ReportSettingLabel = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--cc_color_text_subtle);
  margin: 4px 0px;
`;

/**
 * @deprecated Use { InputText } from `@companycam/slab-web` instead
 *
 * https://slab-web.cocam.co/?path=/docs/inputtext--docs
 */

const TextInput = ({
  id,
  name,
  type,
  label,
  value,
  error,
  onChange,
  reportSetting,
  inputRef,
  ...props
}) => {
  const classNames = cx('input-wrap', { error });
  const controlledInput = typeof value !== 'undefined';

  return (
    <div className={classNames}>
      {reportSetting ? (
        <ReportSettingLabel htmlFor={name}>{label}</ReportSettingLabel>
      ) : null}
      <input
        ref={inputRef}
        id={id || name}
        type={type || 'text'}
        name={name}
        value={controlledInput ? value || '' : undefined}
        onChange={onChange}
        placeholder={props.placeholder || ''}
        {...props}
      />
      {!reportSetting ? <label htmlFor={name}>{label}</label> : null}
      {error ? <span className="validation-error">{error}</span> : null}
    </div>
  );
};

TextInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  reportSetting: PropTypes.bool,
  placeholder: PropTypes.string,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

export default TextInput;
